module.exports = __webpack_public_path__ + "media/images/niq-subtract-badd554d0290c196af7e0c8001e1a597.svg";